// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  margin: 3px 0;
  border: 1px solid #e6e7e3;
  border-radius: 5px;
  box-shadow: none;
  word-break: break-word;
  --color: black;
  --preorder-type-chip-border-color: #f2f2f2;
  --preorder-type-chip-background: #f2f2f2;
  --preorder-type-chip-color: var(--ion-color-primary);
}
ion-card ion-card-content {
  border-top: 1px solid #e6e7e3;
  padding: 10px;
}
ion-card ion-card-content:first-of-type {
  border: none;
}

ion-col b {
  font-family: AppFont, sans-serif;
}

.your-order-title {
  text-transform: uppercase;
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
}

.header {
  font-size: 20px;
  font-family: AppFontExtraBold, sans-serif;
}

ion-chip {
  background: #e2dcd5;
  color: var(--ion-color-primary);
  height: 20px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin: 0px;
  font-size: 11px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/my-order/my-order.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,0CAAA;EACA,wCAAA;EACA,oDAAA;AACD;AAAC;EACC,6BAAA;EACA,aAAA;AAEF;AAAE;EACC,YAAA;AAEH;;AAGC;EACC,gCAAA;AAAF;;AAIA;EACC,yBAAA;EACA,iCAAA;EACA,oCAAA;AADD;;AAGA;EACC,eAAA;EACA,yCAAA;AAAD;;AAEA;EACC,mBAAA;EACA,+BAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AACD","sourcesContent":["ion-card {\n\tmargin: 3px 0;\n\tborder: 1px solid #e6e7e3;\n\tborder-radius: 5px;\n\tbox-shadow: none;\n\tword-break: break-word;\n\t--color: black;\n\t--preorder-type-chip-border-color: #f2f2f2;\n\t--preorder-type-chip-background: #f2f2f2;\n\t--preorder-type-chip-color: var(--ion-color-primary);\n\tion-card-content {\n\t\tborder-top: 1px solid #e6e7e3;\n\t\tpadding: 10px;\n\n\t\t&:first-of-type {\n\t\t\tborder: none;\n\t\t}\n\t}\n}\nion-col {\n\tb {\n\t\tfont-family: AppFont, sans-serif;\n\t}\n}\n\n.your-order-title {\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-secondary);\n\tfont-family: AppFontBold, sans-serif;\n}\n.header {\n\tfont-size: 20px;\n\tfont-family: AppFontExtraBold, sans-serif;\n}\nion-chip {\n\tbackground: #e2dcd5;\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\tpadding-top: 0px;\n\tpadding-bottom: 0px;\n\tmargin: 0px;\n\tfont-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
